var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_mobile",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8506",
    "data-name": "Group 8506",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8505",
    "data-name": "Group 8505",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12377",
    "data-name": "Path 12377",
    d: "M28.5,29.5v-11A2.5,2.5,0,0,0,26,16H4a2.5,2.5,0,0,0-2.5,2.5V26A1.5,1.5,0,0,0,0,27.5v15A1.5,1.5,0,0,0,1.5,44h11A1.5,1.5,0,0,0,14,42.5H18.19a1.5,1.5,0,0,0,1.447-1.895L18.654,37H21.5v5.5A1.5,1.5,0,0,0,23,44h5.5A1.5,1.5,0,0,0,30,42.5V31A1.5,1.5,0,0,0,28.5,29.5ZM13,42.5a.5.5,0,0,1-.5.5H1.5a.5.5,0,0,1-.5-.5v-1H13Zm0-2H1v-11H13Zm0-12H1v-1a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,.5.5Zm5.673,12.368a.5.5,0,0,1-.482.632H14v-1h4.573ZM14,39.5V37h3.618l.682,2.5ZM21.5,36H14V33h7.5Zm0-5v1H14V27.5A1.5,1.5,0,0,0,12.5,26H2.5V18.5A1.5,1.5,0,0,1,4,17H26a1.5,1.5,0,0,1,1.5,1.5v11H23A1.5,1.5,0,0,0,21.5,31ZM29,42.5a.5.5,0,0,1-.5.5H23a.5.5,0,0,1-.5-.5v-1H29Zm0-2H22.5V33H29ZM29,32H22.5V31a.5.5,0,0,1,.5-.5h5.5a.5.5,0,0,1,.5.5Z",
    transform: "translate(0 -16)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8508",
    "data-name": "Group 8508",
    transform: "translate(2.578 34.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8507",
    "data-name": "Group 8507",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    width: 2.756,
    height: 0.974,
    transform: "translate(0 1.949) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8510",
    "data-name": "Group 8510",
    transform: "translate(4.68 32.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8509",
    "data-name": "Group 8509",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    width: 8.268,
    height: 0.974,
    transform: "translate(0 5.846) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8512",
    "data-name": "Group 8512",
    transform: "translate(5.666 30.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8511",
    "data-name": "Group 8511",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 4.134,
    height: 0.974,
    transform: "translate(0 2.923) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8514",
    "data-name": "Group 8514",
    transform: "translate(23.808 34.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8513",
    "data-name": "Group 8513",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1564",
    "data-name": "Rectangle 1564",
    width: 3.444,
    height: 0.974,
    transform: "translate(0 2.436) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8516",
    "data-name": "Group 8516",
    transform: "translate(24.782 36.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8515",
    "data-name": "Group 8515",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1565",
    "data-name": "Rectangle 1565",
    width: 3.444,
    height: 0.974,
    transform: "translate(0 2.436) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8518",
    "data-name": "Group 8518",
    transform: "translate(13.193 21.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8517",
    "data-name": "Group 8517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 4.134,
    height: 0.974,
    transform: "translate(0 2.923) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8520",
    "data-name": "Group 8520",
    transform: "translate(17.71 20.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8519",
    "data-name": "Group 8519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1567",
    "data-name": "Rectangle 1567",
    width: 4.134,
    height: 0.974,
    transform: "translate(0 2.923) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8522",
    "data-name": "Group 8522",
    transform: "translate(14.683 24.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8521",
    "data-name": "Group 8521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 2.756,
    height: 0.974,
    transform: "translate(0 1.949) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8524",
    "data-name": "Group 8524",
    transform: "translate(17.187 18.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8523",
    "data-name": "Group 8523",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1569",
    "data-name": "Rectangle 1569",
    width: 2.763,
    height: 0.974,
    transform: "translate(0 1.954) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8526",
    "data-name": "Group 8526",
    transform: "translate(3.472 18.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8525",
    "data-name": "Group 8525",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1570",
    "data-name": "Rectangle 1570",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8528",
    "data-name": "Group 8528",
    transform: "translate(6.845 18.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8527",
    "data-name": "Group 8527",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1571",
    "data-name": "Rectangle 1571",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8530",
    "data-name": "Group 8530",
    transform: "translate(6.859 18.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8529",
    "data-name": "Group 8529",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 2.132,
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.a8f24137f42bfd0163b4a5558b8c79ec.svg";
export { ForwardRef as ReactComponent };